import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  search: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'search' }),
}

export { paths }
